import i18n from '@/core/i18n';
import { DEFAULT_PAGE_SIZE } from '@/lib/constants/pagination';
import { getShortTeamMembers } from '@/modules/team/api/team.api';
import { renderTeamMemberFilterLabel } from '@/modules/team/helpers/team-member-dropdown-option';
import { FilterConfig, FilterOption } from '@/types/filters';

import {
  TIME_OFF_CHANGES_FILTER_KEY_CHANGED_BY,
  TIME_OFF_CHANGES_FILTER_KEY_DATE_RANGE,
} from './time-off-changes-filter-keys';

/**
 * Filters for the time-off type Changes tab: a date range and a paginated
 * "Changed by" team-member autocomplete (mirrors the project/team Changes tabs).
 */
export const getTimeOffChangesTabFiltersConfig = (): FilterConfig[] => [
  {
    type: 'dateRange',
    name: TIME_OFF_CHANGES_FILTER_KEY_DATE_RANGE,
    label: i18n.t('authenticated.settings:pages.timeOff.details.changesTab.filters.dateRange'),
  },
  {
    type: 'dynamic-autocomplete-paginated',
    name: TIME_OFF_CHANGES_FILTER_KEY_CHANGED_BY,
    label: i18n.t('authenticated.settings:pages.timeOff.details.changesTab.filters.changedBy'),
    withSearch: true,
    loadItems: async (params: {
      searchString?: string;
      cursor?: number | null;
      [key: string]: unknown;
    }) =>
      getShortTeamMembers({
        filter: params.searchString ? { searchString: params.searchString } : undefined,
        pagination: { pageSize: DEFAULT_PAGE_SIZE, cursor: params.cursor },
      }),
    // Scroll-on-hover name + status badge. Status comes from the option (DTO value
    // passed through by the paginated filter); the scheduled archive/unarchive warning
    // icon is omitted because the short endpoint doesn't return those dates (OPS-1548).
    CustomLabelComponent: (value: string, opt: FilterOption) =>
      renderTeamMemberFilterLabel(value, { label: value, avatar: opt.avatar, status: opt.status }),
  },
];
